var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKeycardPrinting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 102.543,
    height: 82.599,
    viewBox: "0 0 102.543 82.599",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1007",
    "data-name": "Group 1007",
    transform: "translate(-621 -219.7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M83.983,5H10.22A9.23,9.23,0,0,0,1,14.22V63.4a9.23,9.23,0,0,0,9.22,9.22H83.983A9.23,9.23,0,0,0,93.2,63.4V14.22A9.23,9.23,0,0,0,83.983,5ZM10.22,11.147H83.983a3.077,3.077,0,0,1,3.073,3.073V54.175H7.147V14.22A3.077,3.077,0,0,1,10.22,11.147ZM83.983,66.469H10.22A3.077,3.077,0,0,1,7.147,63.4V60.322H87.056V63.4A3.077,3.077,0,0,1,83.983,66.469Z",
    transform: "matrix(0.985, -0.174, 0.174, 0.985, 619.146, 230.961)",
    fill: "#4c5152"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M8.073,27.441h3.073v3.073a3.073,3.073,0,0,0,6.147,0V27.441h6.147v3.073a3.073,3.073,0,0,0,6.147,0V27.441H48.277c1.142,7.005,6.108,12.294,12.045,12.294,6.779,0,12.294-6.894,12.294-15.367S67.1,9,60.322,9c-5.937,0-10.9,5.288-12.045,12.294H8.073a3.073,3.073,0,1,0,0,6.147ZM60.322,15.147c3.332,0,6.147,4.223,6.147,9.22s-2.815,9.22-6.147,9.22-6.147-4.223-6.147-9.22S56.99,15.147,60.322,15.147Z",
    transform: "matrix(0.985, -0.174, 0.174, 0.985, 628.754, 237.688)",
    fill: "#4c5152"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeycardPrinting);
export default __webpack_public_path__ + "static/media/keycardPrinting.1bdb8b2ffdc8c4a89a0250c55b88b653.svg";
export { ForwardRef as ReactComponent };